import { render, staticRenderFns } from "./CustomerAddressList.vue?vue&type=template&id=72488e4f&"
import script from "./CustomerAddressList.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports